import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../../components/Table";
import ProductSurchargeItem from "./ProductSurchargeItem";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {GET_SHOP_SURCHARGES, ON_SHOP_SURCHARGE_UPDATED} from "../../../queries/sales";


function getItemKey(item) {
  return `${item.get("productSku")}-${item.get("countryCode")}-${item.get("stateCode")}`;
}

class ShopSurchargesList extends Component {

  componentDidUpdate(prevProps, prevState) {
    const isLoaded = !this.props.loading;
    const hasSubscription = this.unsubscribeFromUpdates;
    if (hasSubscription && (prevProps.shopId !== this.props.shopId)) {
      this.unsubscribe();
    }
    if (isLoaded && !hasSubscription) {
      this.subscribe(this.props.shopId);
    }
  }

  subscribe(shopId) {
    console.log("Subscribing to: ", shopId);
    this.unsubscribeFromUpdates = this.props.subscribeToUpdates(this.props, {});
  }

  unsubscribe() {
    console.log("Unsubscribing");
    if (this.unsubscribeFromUpdates) {
      this.unsubscribeFromUpdates();
      this.unsubscribeFromUpdates = null;
    }
  }


  render() {
    let {loading, error, shopSurcharges} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    const surcharges = fromJS(shopSurcharges);
    if (surcharges.size === 0) return null;
    let tableHeader = List([
      "Sku",
      "Country",
      "State / Province",
      "Surcharge"
    ])
    return (
      <React.Fragment>
        <h5>Product Surcharges</h5>
        <Table 
          data={surcharges} 
          renderer={ProductSurchargeItem} 
          tableHeader={tableHeader}
          onItemClick={this.handleItemClick.bind(this)}
          selected={this.props.selectedId}
          mode="table"
          getItemKey={getItemKey}
          />
      </React.Fragment>
    )
  }

  handleItemClick(itemData, e, field) {
    this.props.onSelectionChange(e, itemData);
  }  
}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_SHOP_SURCHARGE_UPDATED,
      variables: {
        shopId: props.shopId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }  
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(GET_SHOP_SURCHARGES, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      shopId: props.shopId
    }
  })
});

export default withQuery(withSubscription(ShopSurchargesList));